<template>
	<div class="lime-body">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                    <flash-message  id="flash-message" ></flash-message>
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb breadcrumb-separator-1">
                                <li class="breadcrumb-item"><router-link to="/invoice"><a href="#">Invoice</a></router-link></li>
                                <li class="breadcrumb-item active" aria-current="page">Invoice Detail</li>
                            </ol>
                        </nav>
                        <loading :active.sync="isLoading" 
                :can-cancel="true" 
                :is-full-page="fullPage"></loading>
                        <div class="page-title">
                            <h3>Invoices</h3>
                            <div class="search-create" v-if="currentPage === 'dashboard'">
<router-link to="/admindashboard"><button class="btn btn-primary" id="invoiceBtn">
                                    <i class="material-icons">arrow_back</i>
                                    Back to Dashboard
                                </button></router-link>
                            </div>
                            <div class="search-create" v-if="currentPage === 'invoicelistpage'">
<router-link to="/invoice"><button class="btn btn-primary" id="invoiceBtn">
                                    <i class="material-icons">arrow_back</i>
                                    Back to Invoice List
                                </button></router-link>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                    <button class="btn btn-primary" id="invoiceBtn" v-if="invoiceDatas.InvoiceData.status ==='open'" v-on:click="changeInvoiceStatus()"> Change Invoice Status</button> &nbsp; &nbsp;<button v-if="invoiceDatas.invoice_pdf !==''" class="btn btn-primary" id="invoiceBtn" v-on:click="downloadStripePdf()"> Download Stripe PDF</button><br/><br/>
                     
                        <div class="card invoice-detail">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Billed To :</label>
                                            <span class="value">{{invoiceDatas.BrandData.brand_name}}</span>
                                        </div>
                                        <div class="form-group">
                                            <label class="control-label">Name :</label>
                                            <span class="value">{{invoiceDatas.BrandData.brand_name}}</span>
                                        </div>
                                        <div class="form-group">
                                            <label class="control-label">Address :</label>
                                            <span class="value">{{invoiceDatas.BrandData.address}}</span>
                                        </div>
                                        <div class="form-group">
                                            <label class="control-label">Phone Number :</label>
                                            <span class="value">{{invoiceDatas.BrandData.contact_no}}</span> 
                                        </div>
                                        <div class="form-group">
                                            <label class="control-label">Currency :</label>
                                            <span class="value">{{invoiceDatas.currency}}</span> 
                                        </div>
                                        <div class="form-group">
                                            <label class="control-label">Due Date :</label>
                                            <span class="value">{{invoiceDatas.due_date}}</span> 
                                        </div>
                                        <div class="form-group" v-if="invoiceDatas.InvoiceData.note">
                                            <label class="control-label">Note :</label>
                                            <span class="value">{{invoiceDatas.InvoiceData.note}}</span> 
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Invoice No :</label>   
                                            <span class="value">{{invoiceDatas.invoice_number ? invoiceDatas.invoice_number : TEMP}}</span>
                                        </div>
                                        <div class="form-group">
                                            <label class="control-label">Billing Method :</label>
                                            <span class="value">Send Invoice</span>
                                        </div>
                                        <div class="form-group">
                                            <label class="control-label">Escrow ({{invoiceDatas.escrowUser.firstname}} {{invoiceDatas.escrowUser.lastname}} {{invoiceDatas.escrowUser.email}})  Split:
                                            </label>
                                            <span class="value">{{invoiceDatas.invoicePercentageData.escrowUser_percentage}}%</span> <span v-if="invoiceDatas.InvoiceData.status === 'released'"> (${{grossAdmin}})</span> 
                                        </div>
                                        <div class="form-group">
                                            <label class="control-label">User A ({{invoiceDatas.userA.firstname}} {{invoiceDatas.userA.lastname}} {{invoiceDatas.userA.email}})  Split:</label>
                                            <span class="value">{{invoiceDatas.invoicePercentageData.userA_percentage}}% 
                                            </span><span  v-if="invoiceDatas.InvoiceData.status === 'released'">(${{grossUserA}})</span>
                                        </div>
                                        <div class="form-group" v-if="invoiceDatas.userB.firstname">
                                            <label class="control-label">User B ({{invoiceDatas.userB.firstname}} {{invoiceDatas.userB.lastname}} {{invoiceDatas.userB.email}}) Split:</label>
                                            <span class="value">{{invoiceDatas.invoicePercentageData.userB_percentage}}% 
                                            </span> <span v-if="invoiceDatas.InvoiceData.status === 'released'">(${{grossUserB}})</span>
                                        </div>
                                        <div class="form-group"  v-if="invoiceDatas.userC.firstname">
                                            <label class="control-label">User C ({{invoiceDatas.userC.firstname}} {{invoiceDatas.userC.lastname}} {{invoiceDatas.userC.email}}) Split:</label>
                                            <span class="value">{{invoiceDatas.invoicePercentageData.userC_percentage}}% 
                                            </span> <span v-if="invoiceDatas.InvoiceData.status === 'released'">(${{grossUserC}})</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-responsive">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th scope="col">Description</th>
                                                <th scope="col">Qty</th>
                                                <th scope="col">Unit Price</th>
                                                <th scope="col">Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{{invoiceDatas.InvoiceData.description}}</td>
                                                <td>1</td>
                                                <td>${{(invoiceDatas.InvoiceData.amount)}}</td>
                                                <td>${{(invoiceDatas.InvoiceData.amount)}}</td>
                                            </tr>
                                             <tr v-if="invoiceDatas.InvoiceData.status === 'paid' || invoiceDatas.InvoiceData.status === 'released'">
                                                <td></td>
                                                <td></td>
                                                <td>Stripe Fees</td>
                                                <td>${{invoiceDatas.stripe_fee}}</td>
                                            </tr>
                                            <tr v-if="invoiceDatas.InvoiceData.status === 'paid' || invoiceDatas.InvoiceData.status === 'released'">
                                                <td></td>
                                                <td></td>
                                                <td>Net Amount</td>
                                                <td >${{(invoiceDatas.net_amount)}}</td>
                                            </tr>
                                           
                                            <tr>
                                                <td></td>
                                                <td></td>
                                                <td>Gross Amount</td>
                                                <td>${{(invoiceDatas.InvoiceData.amount)}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>      
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
  import axios from 'axios'
  import changeInvoiceStatus from './changeInvoiceStatus'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'
  export default {
    name: 'invoiceDetail',
    components: {
      Loading
    },
    data () {
      return {
        isLoading: false,
        fullPage: true,
        invoiceDatas: '',
        currentPage: '',
        grossAdmin: '',
        afterDate: '',
        grossUserA:'',
        grossUserB:'',
        grossUserC:0
      }
    },
    methods: {
        changeInvoiceStatus(){
         this.$modal.show(changeInvoiceStatus, { height: '100%' })

        },
        downloadStripePdf(){
            console.log(this.invoiceDatas.invoice_pdf)
            window.open(this.invoiceDatas.invoice_pdf)
        }

    },
    mounted () {
      var jwttoken = localStorage.getItem('jwt')
      var currentUrl = window.location.href
      console.log('invoiceid = ' + currentUrl)
      var splitUrl = currentUrl.split('/')
      var invoiceId = splitUrl[4]
      var page = splitUrl[5]
      this.currentPage = page
      // console.log('invoicepage ' + this.currentPage)
      this.isLoading = true
      axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getInvoiceById' + '?' + 'invoice_id' + '=' + invoiceId, {
        headers: {
          'x-access-token': jwttoken
        }})
        .then(response => {
            this.isLoading = false
          this.invoiceDatas = response.data.results
          var adminPer = response.data.results.invoicePercentageData.escrowUser_percentage
          var UserAPer = response.data.results.invoicePercentageData.userA_percentage
          var UserBPer = response.data.results.invoicePercentageData.userB_percentage
          var UserCPer = response.data.results.invoicePercentageData.userC_percentage ?  response.data.results.invoicePercentageData.userC_percentage :0;
          var amt = response.data.results.net_amount
          this.grossAdmin = ((adminPer * amt)/100).toFixed(2)
          this.grossUserA = ((UserAPer * amt)/100).toFixed(2)
          this.grossUserB = ((UserBPer * amt)/100).toFixed(2)
          this.grossUserC = ((UserCPer * amt)/100).toFixed(2)
          
          // this.invoiceDatas.invoicePercentageData.admin_percentage
          
        })
        .catch((error) => {
          // this.errorMessage = response.data.errors
          console.log(error)
          this.isLoading = false
        })

        this.$eventBus.$on('changeInvoiceStatus', (data,error,time) => { 
           const messageStorage = this.flash();
          if (data) {  
             // this.getInvoice() ;
             this.$forceUpdate();
             messageStorage.destroyAll()
             if(time){
             this.flash(data, 'success', {timeout: time }); 
             }else {
              this.flash(data, 'success', {timeout: 3000 }); 
             }
          }
          else if (error) { 
            if(time){
             this.flash(error, 'error', {timeout: time });
            }else {
              this.flash(error, 'error', {timeout: 3000 });
            }
         
          }
      }) 
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/invoiceDetail.vue